enum CardStatus {
  All = "All",
  Pending = "Pending",
  Active = "Active",
  Canceled = "Canceled",
  Frozen = "Frozen",
  Suspended = "Suspended",
}

export default CardStatus;
